import script from "./secnf.vue?vue&type=script&setup=true&lang=js"
export * from "./secnf.vue?vue&type=script&setup=true&lang=js"

import "./secnf.vue?vue&type=style&index=0&id=3ab563a9&lang=scss"

const __exports__ = script;

export default __exports__